/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Filter_ToInputs */

const vi_cashflow_filter_to = /** @type {(inputs: Cashflow_Filter_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đến ngày`)
};

/**

* @param {Cashflow_Filter_ToInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_filter_to = /** @type {((inputs?: Cashflow_Filter_ToInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Filter_ToInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_filter_to(inputs)
});